import { get, post } from "lib/fetch";

export const GET_CONFIG = "config/GET";
export const UPDATE_CONFIG = "config/UPDATE";

export const getConfig = () => ({
  type: GET_CONFIG,
  payload: get(`/v1/config/`),
});
export const updateConfig = (payload: any) => ({
  type: UPDATE_CONFIG,
  payload: post(`/v1/config/`, payload),
});
